(() => {
  const getStep = (track) => {
    const card = track && track.querySelector('.snl-home-product');
    if (!card) return 320;
    const gap = Number(String(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0').replace('px', '')) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  window.snlHomeSlide = (button, direction) => {
    const section = button && button.closest ? button.closest('.snl-home-slider') : null;
    const track = section && section.querySelector('[data-snl-home-track]');
    if (!track) return false;
    track.scrollBy({ left: direction * getStep(track), behavior: 'smooth' });
    return false;
  };

  const init = () => {
    document.querySelectorAll('[data-snl-home-track]').forEach((track) => {
      if (track.dataset.snlLoopReady === 'true') return;
      track.dataset.snlLoopReady = 'true';
      const middle = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (max > 0 && track.scrollLeft < 10) track.scrollTo({ left: Math.floor(max / 2), behavior: 'auto' });
      };
      requestAnimationFrame(middle);
      setTimeout(middle, 500);
      track.addEventListener('scroll', () => {
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 0) return;
        if (track.scrollLeft < max * 0.08) track.scrollTo({ left: track.scrollLeft + max / 2, behavior: 'auto' });
        if (track.scrollLeft > max * 0.92) track.scrollTo({ left: track.scrollLeft - max / 2, behavior: 'auto' });
      }, { passive: true });
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest && event.target.closest('[data-snl-home-prev], [data-snl-home-next]');
    if (!target) return;
    window.snlHomeSlide(target, target.hasAttribute('data-snl-home-prev') ? -1 : 1);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(() => {
  const start = () => {
  const root = document.documentElement;
  root.classList.add('codex-motion-ready');

  const revealItems = document.querySelectorAll('.codex-reveal, .codex-product-tile, .codex-category-card, .codex-trust > div');
  const revealNowIfInView = (item) => {
    const rect = item.getBoundingClientRect();
    if (rect.top < window.innerHeight * 1.08 && rect.bottom > -80) {
      item.classList.add('is-visible');
      return true;
    }
    return false;
  };

  revealItems.forEach((item, index) => {
    item.style.setProperty('--snl-reveal-delay', `${Math.min(index % 6, 5) * 70}ms`);
    revealNowIfInView(item);
  });

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    revealItems.forEach((item) => io.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  window.setTimeout(() => {
    document.querySelectorAll('.codex-reveal:not(.is-visible)').forEach(revealNowIfInView);
  }, 250);

  const hero = document.querySelector('.codex-hero');
  const visual = document.querySelector('.codex-hero__visual-main');
  if (hero && visual && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    hero.addEventListener('pointermove', (event) => {
      const rect = hero.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      visual.style.transform = `translate3d(${x * 18}px, ${y * 14}px, 0) rotate(${x * 2.2}deg)`;
    });
    hero.addEventListener('pointerleave', () => {
      visual.style.transform = '';
    });
  }

  document.querySelectorAll('.codex-product-tile, .codex-category-card').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      card.style.setProperty('--snl-tilt-x', `${-y * 5}deg`);
      card.style.setProperty('--snl-tilt-y', `${x * 5}deg`);
    });
    card.addEventListener('pointerleave', () => {
      card.style.removeProperty('--snl-tilt-x');
      card.style.removeProperty('--snl-tilt-y');
    });
  });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(() => {
  const getSliderStep = (track) => {
    const card = track && track.querySelector('.snl-home-product');
    if (!card) return Math.max(320, (track && track.clientWidth ? track.clientWidth : 390) * 0.82);
    const gapText = window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0';
    const gap = Number(String(gapText).replace('px', '')) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  window.snlHomeSlide = (button, direction) => {
    const section = button && button.closest ? button.closest('.snl-home-slider') : null;
    const track = section && section.querySelector('[data-snl-home-track]');
    if (!track) return false;
    track.scrollBy({ left: direction * getSliderStep(track), behavior: 'smooth' });
    return false;
  };

  const normalizeTrack = (track) => {
    if (!track || track.dataset.snlLoopReady === 'true') return;
    track.dataset.snlLoopReady = 'true';

    const setMiddle = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max > 0 && track.scrollLeft < 10) {
        track.scrollTo({ left: Math.floor(max / 2), behavior: 'auto' });
      }
    };

    window.requestAnimationFrame(setMiddle);
    window.setTimeout(setMiddle, 500);

    track.addEventListener('scroll', () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      if (track.scrollLeft < max * 0.08) {
        track.scrollTo({ left: track.scrollLeft + max / 2, behavior: 'auto' });
      } else if (track.scrollLeft > max * 0.92) {
        track.scrollTo({ left: track.scrollLeft - max / 2, behavior: 'auto' });
      }
    }, { passive: true });
  };

  const initHomeSliders = () => {
    document.querySelectorAll('[data-snl-home-track]').forEach(normalizeTrack);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-snl-home-prev], [data-snl-home-next]');
    if (!button) return;
    window.snlHomeSlide(button, button.hasAttribute('data-snl-home-prev') ? -1 : 1);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeSliders, { once: true });
  } else {
    initHomeSliders();
  }

  document.addEventListener('shopify:section:load', initHomeSliders);
})();
